var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('QuizContentForm',_vm._g({attrs:{"data":_vm.data,"title":_vm.$t('QUIZZES.TITLE.UPLOAD_MEDIA'),"settings":['allow_multiple_uploads'],"showManualCheck":_vm.showManualCheck}},_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }